import { Dispatch, SetStateAction, useEffect } from 'react'
import toast from 'react-hot-toast'

import { EvaluacionStepper, IEvaluacion } from '../constants'
import FormVideos from '../EvaluacionComponents/FormVideos'
import SedeEntreno from '../EvaluacionComponents/SedeEntreno'
import ActividadFisica from '../EvaluacionComponents/ActividadFisica'
import DiasEntrenamiento from '../EvaluacionComponents/DiasEntrenamiento'
import TiempoEntrenamiento from '../EvaluacionComponents/TiempoEntrenamiento'


interface Props {
  dataEvaluacion: IEvaluacion;
  setSection: Dispatch<SetStateAction<number>>;
  handleChange(type: string, value: string | number): void;
  sexo: boolean;
}

const EntrenamientoSection = ({dataEvaluacion, handleChange, setSection, sexo}: Props) => {


  const handleNext = () => {

    let err5 = false ;

    if(dataEvaluacion.diasPrioridad === undefined){
      err5 = true;
    }
    if( dataEvaluacion.cantidadDiasEntrenamiento === 3 && dataEvaluacion.diasPrioridad === 0 ){
      err5 = true;
    }
    if(dataEvaluacion.cantidadDiasEntrenamiento === 4 && dataEvaluacion.diasPrioridad === 0){
      err5 = true;
    }
    
    if(sexo){
      handleChange('diasPrioridad', 0);
      err5 = false;
    }

    if(err5){
      toast.error('Por favor selecciona una opción de días de prioridad');
      return;
    }

    if (!err5) {
      setSection((sec:number) => sec + 1);
    }

  }

  useEffect(() => {
    const linkToTheTop = document.getElementById('GoToTheTop');
    linkToTheTop.click();
  }, [])

  return (
    <>
      <FormVideos 
        url='https://player.vimeo.com/external/1047862751.m3u8?s=32e89d7f2a380e8029ac2b54e0ca998b74308eba&logging=false'
        evaluation
        noUnderlined
      />

      <ActividadFisica 
        dataEvaluacion={dataEvaluacion}
        handleChange={handleChange}
        sexo={sexo}
      />

      <DiasEntrenamiento 
        dataEvaluacion={dataEvaluacion}
        handleChange={handleChange}
        sexo={sexo}
      />

      <br />

      <TiempoEntrenamiento
        dataEvaluacion={dataEvaluacion}
        handleChange={handleChange}
      />

      <br />

      <SedeEntreno
        dataEvaluacion={dataEvaluacion}
        handleChange={handleChange}
      />

      <br />

      <EvaluacionStepper 
        handleNext={handleNext}
        setSection={setSection}
      />
    </>
  )
}

export default EntrenamientoSection